import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { friendlyError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { Tabs, Chip, Skeleton, EmptyState } from "@/ui";
import { manilaDateTime } from "@/lib/format";
import { Inbox } from "lucide-react";

const TABS = [
  { value: "", label: "All ways" }, { value: "chat", label: "Chat" },
  { value: "shop_page", label: "Shop page" }, { value: "counter", label: "Counter" },
];
const STATUS_TONE = { paid: "good", done: "good", ready: "good", preparing: "warn", out_for_delivery: "warn", cod_unpaid: "warn", awaiting_payment: "warn", cancelled: "bad", refunded: "bad" };

export default function Orders() {
  const { shopId, shopName } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [channel, setChannel] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!shopId) { navigate("/pick-shop", { replace: true }); return; }
    setLoading(true);
    const q = channel ? `&channel=${channel}` : "";
    api.get(`/orders?shopId=${shopId}${q}`).then((r) => setOrders(r.data.orders)).catch((e) => setError(friendlyError(e))).finally(() => setLoading(false));
  }, [shopId, channel, navigate]);

  return (
    <Layout shopName={shopName}>
      <h1 className="t-h1" style={{ marginBottom: 16 }}>orders</h1>
      {error ? <div className="err-text" data-testid="orders-error" style={{ marginBottom: 12 }}>{error}</div> : null}
      <div style={{ marginBottom: 16 }}>
        <div data-testid="orders-channel"><Tabs value={channel} onChange={setChannel} tabs={TABS} /></div>
      </div>

      {loading ? (
        <div className="tbl-wrap"><div style={{ padding: 16 }} className="stack"><Skeleton /><Skeleton /><Skeleton /></div></div>
      ) : orders.length === 0 ? (
        <EmptyState icon={<Inbox size={20} strokeWidth={1.75} />} title="no orders here yet — sales through chat, the shop page or the counter show up here" />
      ) : (
        <div className="tbl-wrap" data-testid="orders-list">
          <table className="tbl">
            <thead><tr><th>Order</th><th>Way</th><th>Status</th><th className="num">Total</th><th>When</th></tr></thead>
            <tbody>
              {orders.map((o) => (
                <tr key={o.id} data-testid={`order-${o.id}`} style={{ cursor: "pointer" }} onClick={() => navigate(`/orders/${o.id}`)}>
                  <td>#{o.id.replace("order-", "")}</td>
                  <td>{o.channelLabel}</td>
                  <td><Chip tone={STATUS_TONE[o.status] || "neutral"} dot>{o.statusLabel}</Chip></td>
                  <td className="num">{o.gross}</td>
                  <td className="muted-3 t-small">{manilaDateTime(o.placedAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
